window.addEventListener('DOMContentLoaded', () => {
  // move sticky .html.erb flash elements (banners) to beginning of HTML <body> for better accessibility
  const $flash = document.querySelector('.erb-flash.sticky');
  if (!$flash) return;
  document.body.prepend($flash);
});